export const getIcons = (state) =>
  state.icons;



// WEBPACK FOOTER //
// ./src/store/selectors/icons.js